<template> </template>
<script>
export default {
  name: "foodBeverage",
  components: {},
  data() {
    return {};
  },
  beforeMount() {
    window.location.assign("https://ksa.empirecinemas.com/premiumMenuScanner");
    //premiumMenuScanner Menue path
  },

  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/pages/fnbcheckout.vue